const Panel = ({ children, className }) => {
  return (
    <div className={`w-full max-w-full overflow-x-auto rounded-[16px] bg-white p-[15px] ${className}`}>
      {children}
    </div>
  )
}

export default Panel
